export const informDetail = {
    path: '/informDetail',
    name: 'informDetail',
    title: '公告详情',
    component: () => import("../components/page/homePage/informDetail"),
    meta:{title:'公告详情'},
}


// WEBPACK FOOTER //
// ./src/router/informDetail.js